







































import '../assets/scss/init.scss'
import { Component, Vue, namespace, Watch } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { ICssVariables, IStyle } from '~/assets/interfaces/classes'
import { IMeta } from '~/assets/interfaces/meta'
import { ISiteScriptItem } from '~/assets/interfaces/site'
import { CONFIG_CSS_API } from '~/assets/config/api-path'
import { filterUrl } from '~/assets/filters/url'
import { runIdle } from '~/assets/functions/runIndle'

const siteStore = namespace('site')
const pageStore = namespace('page')

@Component({
  components: {
    LazyHydrate,
    componentHeader: () => import('~/components/header/header.vue'),
    componentFooter: () => import('~/components/footer/footer.vue'),
    ComponentSystemUnderReconstruction: () =>
      import('~/components/system/sytem-under-reconstruction.vue'),
    ComponentLayoutGeneral: () => import('~/components/layout/general.vue'),
    ComponentAuth: () => import('~/components/auth/auth.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentLoadingDots: () => import('~/components/loading/dots.vue'),
    ComponentSkeletonRect: () => import('~/components/skeleton/rect.vue'),
  },
})
export default class layoutDefault extends Vue {
  @siteStore.State('isHeaderLoaded') private isHeaderLoaded!: boolean
  @pageStore.State('meta') private meta!: IMeta
  @siteStore.State('isConfigInit') private isConfigInit!: boolean
  @siteStore.State('token') private token!: string | null
  @siteStore.State('origin') private origin!: string
  @siteStore.State('brand') private brand!: string
  @siteStore.State('cssVariables') private cssVariables!: ICssVariables | null
  @siteStore.State('scripts') private scripts!: ISiteScriptItem[]
  @siteStore.State('isUnderConstruction') private isUnderConstruction!: boolean

  private isComponentHeaderLoaded = false

  private isShowAuthPopup = false
  private isComponentAuthLoaded = false
  isMounted = false

  public $style!: IStyle

  private get cssVariablesStyle() {
    let style = ':root {'
    for (const item in this.cssVariables) {
      style =
        style +
        (item === 'google-font-family' ? '--' : '--color-') +
        item +
        ': ' +
        this.cssVariables[item] +
        ';'
    }
    style = style + '}'
    return style
  }

  private get googleFontsUrl() {
    if (this.cssVariables && this.cssVariables['google-font-family']) {
      const googleFont = this.cssVariables['google-font-family']
        .trim()
        .replace(/\s/g, '+')
      return `https://fonts.googleapis.com/css2?family=${googleFont}:wght@400;500;700&display=swap`
    }
    return null
  }

  private get googleFontLinks() {
    if (this.cssVariables && this.cssVariables['google-font-family']) {
      return [
        {
          rel: 'preconnect',
          href: 'https://fonts.googleapis.com',
        },
        {
          rel: 'preconnect',
          href: 'https://fonts.gstatic.com',
          crossorigin: true,
        },
        {
          rel: 'preload',
          as: 'style',
          href: this.googleFontsUrl,
        },
        {
          rel: 'stylesheet',
          href: this.googleFontsUrl,
          media: 'print',
          onload: "this.onload=null;this.media='all';",
        },
      ]
    } else {
      return []
    }
  }

  private head() {
    const base: any = {
      __dangerouslyDisableSanitizers: ['script', 'style', 'noscript'],
      bodyAttrs: {
        class: this.$style.body,
      },
      title: this.meta.title || '',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description || '',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta.keywords || '',
        },
        {
          hid: 'robots',
          name: 'robots',
          content: this.meta.robots || '',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.meta.description || '',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: this.meta.title || '',
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: this.meta.image || '',
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          property: 'og:site_name',
          content: this.brand || '',
        },
      ],
      link: [
        {
          rel: 'canonical',
          hid: 'canonical',
          href: this.meta.canonical || this.origin + this.$route.path,
        },
      ],
      style: [
        {
          innerHTML: this.cssVariablesStyle,
        },
      ],
    }
    base.link.push(...this.googleFontLinks)
    this.scripts.forEach((item) => {
      base[item.type] = base[item.type] || []
      base[item.type].push({ ...item.attr })
    })
    return base
  }

  @Watch('token', { immediate: true })
  private tokenHandler(val: string | null) {
    if (val) {
      this.$axios.setToken(val)
    }
  }

  private created() {
    this.$nuxt.$on('open-auth-popup', () => {
      this.isShowAuthPopup = true
    })
  }

  mounted() {
    runIdle(() => {
      this.isMounted = true

      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = filterUrl(this.$config.baseURL + CONFIG_CSS_API)
      link.type = 'text/css'
      document.head.appendChild(link)
    })
  }
}
